import { useT } from "../../i18n/I18nProvider";
import { useMemberRequestCounts } from "./queries";

/** The number of member requests nobody has picked up, in the sidebar. Nothing is drawn while there are none or the count is unknown. */
export function MemberRequestsBadge() {
  const t = useT();
  const counts = useMemberRequestCounts();
  const waiting = counts.data?.new ?? 0;
  if (waiting === 0) return null;
  return (
    <span className="cc-nav__badge">
      <span aria-hidden="true">{waiting > 99 ? "99+" : waiting}</span>
      <span className="sr-only">{t("portal.mr.waitingCount", { count: waiting })}</span>
    </span>
  );
}
